<p-dialog
    data-testid="report-customization-dialog"
    header="{{ getDialogHeader() }}"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onHide()"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '550px' }"
    class="custom-dialog"
>
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-6">
            <p class="font-semibold">{{ "report_col_customization_header" | translate }}</p>
            @if (tableColumns.length > 0) {
                <div
                    class="flex flex-col"
                    pTooltip="{{ 'activities_report_customization_proFeature' | translate }}"
                    [tooltipDisabled]="licenseStatePro"
                    tooltipPosition="bottom"
                >
                    @if (isAdminOrManager) {
                        <div class="flex items-center gap-4 mb-2">
                            <p-checkbox
                                data-testid="report-column-user"
                                [inputId]="'user'"
                                [disabled]="!licenseStatePro"
                                [binary]="true"
                                [(ngModel)]="tableColumns[0].visible"
                                [ngModelOptions]="{ standalone: true }"
                            />
                            <label for="user">{{ "activities_user" | translate }}</label>
                        </div>
                    }

                    <!-- layers checkboxes -->
                    @for (layer of layers; track layer.name; let i = $index) {
                        @if (layer.visible) {
                            <div class="flex items-center gap-4 mb-2">
                                <p-checkbox
                                    [attr.data-testid]="'report-column-layer-' + (i + 1)"
                                    [inputId]="'layer:' + i"
                                    [disabled]="!licenseStatePro"
                                    [binary]="true"
                                    [(ngModel)]="tableColumns[i + 1].visible"
                                    [ngModelOptions]="{ standalone: true }"
                                />
                                <label [for]="'layer:' + i">{{ layer.name }}</label>
                            </div>
                        }
                    }

                    <!-- note checkbox -->
                    <div class="flex items-center gap-4 mb-2">
                        <p-checkbox
                            data-testid="report-column-note"
                            [inputId]="'note'"
                            [disabled]="!licenseStatePro"
                            [binary]="true"
                            [(ngModel)]="tableColumns[4].visible"
                            [ngModelOptions]="{ standalone: true }"
                        />
                        <label for="note">{{ "activities_note" | translate }}</label>
                    </div>
                    <!-- date -->
                    <div class="flex items-center gap-4 mb-2">
                        <p-checkbox
                            data-testid="report-column-date"
                            [inputId]="'date'"
                            [disabled]="!licenseStatePro"
                            [binary]="true"
                            [(ngModel)]="tableColumns[5].visible"
                            [ngModelOptions]="{ standalone: true }"
                        />
                        <label for="date">{{ "activities_date" | translate }}</label>
                    </div>
                    <!-- time -->
                    <div class="flex items-center gap-4 mb-2">
                        <p-checkbox
                            data-testid="report-column-time"
                            [inputId]="'time'"
                            [disabled]="!licenseStatePro"
                            [binary]="true"
                            [(ngModel)]="tableColumns[6].visible"
                            [ngModelOptions]="{ standalone: true }"
                        />
                        <label for="time">{{ "activities_time" | translate }}</label>
                    </div>
                    <!-- duration -->
                    <div class="flex items-center gap-4 mb-2">
                        <p-checkbox
                            data-testid="report-column-duration"
                            [inputId]="'duration'"
                            [disabled]="!licenseStatePro"
                            [binary]="true"
                            [(ngModel)]="tableColumns[7].visible"
                            [ngModelOptions]="{ standalone: true }"
                        />
                        <label for="duration">{{ "activities_duration" | translate }}</label>
                    </div>
                    <!-- billed (only admins and manager, invisible for regular users)-->
                    @if (isAdminOrManager) {
                        <div class="flex items-center gap-4 mb-2">
                            <p-checkbox
                                data-testid="report-column-billed"
                                [inputId]="'billed'"
                                [disabled]="!licenseStatePro"
                                [binary]="true"
                                [(ngModel)]="tableColumns[8].visible"
                                [ngModelOptions]="{ standalone: true }"
                            />
                            <label for="billed">{{ "activities_billed" | translate }}</label>
                        </div>
                    }
                </div>
            }
        </div>
        <div class="col-span-6">
            <div class="p-fluid">
                <div
                    class="settings-field-right"
                    pTooltip="{{ 'activities_report_customization_proFeature' | translate }}"
                    [tooltipDisabled]="licenseStatePro"
                    tooltipPosition="right"
                >
                    <label for="dropdownDateformat">{{ "date_format_label" | translate }}</label>
                    <p-select
                        data-testid="report-date-format"
                        [disabled]="!licenseStatePro"
                        inputId="dropdownDateformat"
                        [options]="dateFormats"
                        [(ngModel)]="selectedDateFormat"
                        optionValue="code"
                        optionLabel="name"
                    />
                </div>
                <!-- Time format selectButton -->
                <div
                    class="settings-field-right"
                    pTooltip="{{ 'activities_report_customization_proFeature' | translate }}"
                    [tooltipDisabled]="licenseStatePro"
                    tooltipPosition="right"
                >
                    <label>{{ "time_format_label" | translate }}</label>
                    <p-selectButton
                        data-testid="report-time-format"
                        [allowEmpty]="false"
                        [disabled]="!licenseStatePro"
                        [options]="timeFormats"
                        [(ngModel)]="selectedTimeFormat"
                        optionValue="code"
                        optionLabel="name"
                    />
                </div>

                <!-- Duration format selectButton -->
                <div
                    class="settings-field-right"
                    pTooltip="{{ 'activities_report_customization_proFeature' | translate }}"
                    [tooltipDisabled]="licenseStatePro"
                    tooltipPosition="right"
                >
                    <label>{{ "duration_settings" | translate }}</label>
                    <p-selectButton
                        data-testid="report-duration-format"
                        [allowEmpty]="false"
                        [disabled]="!licenseStatePro"
                        [options]="durationFormats"
                        [(ngModel)]="selectedDurationFormat"
                        optionValue="code"
                        optionLabel="name"
                    />
                </div>
                <div
                    class="settings-field-right"
                    [pTooltip]="
                        (!licenseStatePro ? 'activities_report_customization_proFeature' : !isLogoUploaded() ? 'report_logo_not_uploaded' : '') | translate
                    "
                    tooltipPosition="right"
                >
                    <label for="dropdownReportLogo">{{ "report_logo_header" | translate }}</label>
                    <p-select
                        data-testid="report-logo-option"
                        [options]="reportLogoOptions"
                        [(ngModel)]="reportLogoOption"
                        placeholder="{{ 'select_logo' | translate }}"
                        optionLabel="name"
                        [disabled]="!licenseStatePro || !isLogoUploaded()"
                    >
                        <ng-template let-item pTemplate="item">
                            <div class="custom-item flex items-center">
                                <!-- logo for the default timebuzzer -->
                                <img *ngIf="item.id === 0" [src]="defaultLogoBase64" style="max-width: 80px; height: 20px; margin-right: 8px" />
                                <!-- Image for the custom logo option -->
                                <img *ngIf="item.id === 1" [src]="uploadedCustomLogoUrl" style="max-width: 80px; height: 20px; margin-right: 8px" />
                                <span style="white-space: nowrap">
                                    <ng-container *ngIf="item.id === 0; else notTimeBuzzer"> timeBuzzer </ng-container>

                                    <ng-template #notTimeBuzzer>
                                        <ng-container *ngIf="item.id === 1 && uploadedCustomLogoUrl; else uploadLogo">
                                            {{ item.name }}
                                        </ng-container>
                                    </ng-template>

                                    <ng-template #uploadLogo> Upload logo </ng-template>
                                </span>
                                <!-- Spacer div to push button to the right -->
                                <div class="grow"></div>
                                <!-- Conditionally displayed button, aligned to the right -->
                                @if (item.id === 1 && isAdmin) {
                                    <button
                                        type="button"
                                        pButton
                                        pRipple
                                        (click)="onButtonClick($event)"
                                        class="p-button-outlined ml-2"
                                        pTooltip="Change Logo"
                                        tooltipPosition="top"
                                    >
                                        <i class="pi pi-pencil"></i>
                                    </button>
                                }
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <!-- pdf orientation -->
                <div
                    class="settings-field-right"
                    pTooltip="{{ 'activities_report_customization_proFeature' | translate }}"
                    [tooltipDisabled]="licenseStatePro"
                    tooltipPosition="right"
                >
                    <label for="pdfOrientation">{{ "pdf_orientation_label" | translate }}</label>
                    <p-selectButton
                        data-testid="report-pdf-orientation"
                        [allowEmpty]="false"
                        [disabled]="!licenseStatePro"
                        [options]="pdfOrientationOptions"
                        [(ngModel)]="pdfOrientation"
                        optionValue="code"
                        optionLabel="name"
                    />
                </div>
                <!-- Pdf heading setting -->
                <div
                    class="settings-field-right"
                    pTooltip="{{ 'activities_report_customization_proFeature' | translate }}"
                    [tooltipDisabled]="licenseStatePro"
                    tooltipPosition="right"
                >
                    <label for="reportHeading">{{ "pdf_heading_label" | translate }}</label>
                    <input
                        data-testid="report-pdf-heading"
                        pInputText
                        [disabled]="!licenseStatePro"
                        id="reportHeading"
                        [(ngModel)]="pdfReportHeading"
                        (blur)="onReportHeadingBlur()"
                        required
                        maxlength="30"
                    />
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 flex justify-end">
                <button
                    type="submit"
                    pButton
                    (click)="onCancel()"
                    label="{{ 'button_cancel' | translate }}"
                    severity="secondary"
                    class="p-button-text mr-2"
                ></button>
                <p-button
                    data-testid="report-settings-save"
                    icon="pi pi-save"
                    label="{{ 'button_save' | translate }}"
                    iconPos="left"
                    [disabled]="!licenseStatePro"
                    (onClick)="save()"
                ></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
